import React from 'react';

const WarmGradientOrbs = () => (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-gradient-to-br from-amber-200/50 via-rose-200/30 to-transparent blur-3xl" />
        <div className="absolute top-[25%] -right-40 w-[500px] h-[500px] rounded-full bg-gradient-to-bl from-orange-200/50 via-yellow-200/30 to-transparent blur-3xl" />
        <div className="absolute bottom-[-10%] left-[25%] w-[600px] h-[600px] rounded-full bg-gradient-to-tr from-[#d4a056]/25 via-rose-100/30 to-transparent blur-3xl" />
    </div>
);

export default WarmGradientOrbs;
